import { createZoomMarker } from 'app/core/markers/models';
import { InsertConvex } from './InsertConvex';
const Consts = {
    defaultBasicRadius: 40,
};
export const InsertZoom = () => {
    const createMarker = (point, size, sizeFactor) => createZoomMarker({
        x: point.x,
        y: point.y,
        size: 6 /* MarkerSize.s2 */,
        radius: Consts.defaultBasicRadius / sizeFactor,
        zoom: 1 + 2 * (size / 15 /* MarkerSize.s5 */),
    });
    return InsertConvex(createMarker);
};
